/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router";
import {
  ControlledInput,
  PrimaryButton,
  SecondaryButton,
} from "../../components";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useLeadingSources } from "../../store/useLeadingSources";

type Inputs = {
  name: string;
};

function EditLeadingSourceScreen() {
  /** Params */
  const params = useParams();
  /** Hooks */
  const {
    updateLeadingSource,
    updatedLeadingSource,
    clearUpdatedLeadingSource,
    getLeadingSource,
    leadingSource,
  } = useLeadingSources();
  const navigate = useNavigate();
  const {
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  /** Effects */
  useEffect(() => {
    if (updatedLeadingSource) {
      clearUpdatedLeadingSource();
      navigate(-1);
    }
  }, [updatedLeadingSource]);

  useEffect(() => {
    getLeadingSource(params?.id as string);
  }, []);

  useEffect(() => {
    if (leadingSource) {
      reset({
        name: leadingSource.name,
      });
    }
  }, [leadingSource]);

  /** Callbacks */
  const goBack = () => navigate(-1);

  const onSubmit = async (data: Inputs) => {
    updateLeadingSource(params?.id as string, data);
  };

  return (
    <div>
      <div className="flex flex-row items-center mb-6">
        <h1 className="font-satoshi text-2xl font-bold text-dark">
          Edit Leading Source
        </h1>
      </div>
      <div className="flex flex-col sm:flex-row">
        <div className="w-full sm:w-1/2 bg-white border border-gray-border drop-shadow-md mb-1 sm:mb-0">
          <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
            <p className="font-satoshi font-medium text-base text-dark">
              Update Leading Source details
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="w-full px-7 py-7">
            <ControlledInput
              control={control}
              error={Boolean(errors?.name)}
              label="Name"
              placeholder="Leading Source name"
              name="name"
              rules={{ required: true }}
            />
            <div className="flex flex-row items-center justify-end">
              <SecondaryButton type="button" onClick={goBack} label="Cancel" />
              <PrimaryButton type="submit" className="ml-4" label="Save" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default withProtectedRoute(EditLeadingSourceScreen);
